import {createAction} from "redux-actions";
import * as ACTION from "./constants";

export const fetchTemplateBags = createAction(ACTION.FETCH_TEMPLATE_BAGS.REQUEST, (params) => ({params}));
export const createTemplateBag = createAction(ACTION.CREATE_TEMPLATE_BAG.REQUEST, (data) => ({data}));
export const updateTemplateBag = createAction(ACTION.UPDATE_TEMPLATE_BAG.REQUEST, (id, data) => ({id, data}));
export const fetchTemplateBagDetail = createAction(ACTION.FETCH_TEMPLATE_BAG_DETAIL.REQUEST, (id, params) => ({id, params}));
export const resetError = createAction(ACTION.RESET_ERROR, (field) => ({field}));
export const clearStateTemplateBag = createAction(ACTION.CLEAR_STATE_TEMPLATE_BAG);